import isObject from '../util/isObject';
export default function deproxy(obj) {
    const isObj = isObject(obj), isArray = Array.isArray(obj);
    if (!isObj && !isArray)
        return obj;
    if (isArray) {
        obj = obj.slice();
        for (let i = 0, l = obj.length; i < l; ++i) {
            obj[i] = deproxy(obj[i]);
        }
    }
    else {
        obj = Object.assign({}, obj);
        const keys = Object.keys(obj);
        for (let i = 0, l = keys.length; i < l; ++i) {
            obj[keys[i]] = deproxy(obj[keys[i]]);
        }
    }
    return obj;
}
//# sourceMappingURL=deproxy.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kompo/lib/util/deproxy.js
// module id = 31
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11